import { cacheDom } from '../utils/QuerySelectors.js'
import { validateEmail, trapFocus } from '../utils/helpers.js'
import { sha256 } from '../utils/Gtm.js'

const dom = {}
const qs = {
  section: 'data-section-type="footer"',
  newsletterPopTrigger: 'data-newsletter-pop-trigger',
  newsletterPopSubmit: 'data-newsletter-pop-submit',
  newsletterPopEmail: 'data-newsletter-pop-email',
  newsletterPopTitle: 'data-newsletter-pop-title',
  newsletterPopFirstName: 'data-newsletter-pop-firstname',
  newsletterPopLastName: 'data-newsletter-pop-lastname',
  newsletterPopCountry: 'data-newsletter-pop-country',
  fieldError: 'data-field-error',
}
const qsAll = {}

const initSignupForm = () => {
  const newsletterPopSubmit = document.querySelector(`[${qs.newsletterPopSubmit}]`)
  const newsletterPopEmail = document.querySelector(`[${qs.newsletterPopEmail}]`)
  const newsletterPopTitle = document.querySelector(`[${qs.newsletterPopTitle}]`)
  const newsletterPopFirstName = document.querySelector(`[${qs.newsletterPopFirstName}]`)
  const newsletterPopLastName = document.querySelector(`[${qs.newsletterPopLastName}]`)
  const newsletterPopCountry = document.querySelector(`[${qs.newsletterPopCountry}]`)

  if(newsletterPopSubmit) {
    newsletterPopEmail.focus()

    newsletterPopEmail.addEventListener('input', () => {
      const wrap = newsletterPopEmail.closest('.input-wrap')
      wrap?.classList.remove('input-error')
      wrap?.querySelector(`[${qs.fieldError}]`).classList.add('hidden')
    })
    newsletterPopFirstName.addEventListener('input', () => {
      const wrap = newsletterPopFirstName.closest('.input-wrap')
      wrap?.classList.remove('input-error')
      wrap?.querySelector(`[${qs.fieldError}]`).classList.add('hidden')
    })
    newsletterPopTitle.addEventListener('change', () => {
      const wrap = newsletterPopTitle.closest('.select-wrap')
      wrap?.classList.remove('select-error')
      wrap?.querySelector(`[${qs.fieldError}]`).classList.add('hidden')
    })
    trapFocus(newsletterPopEmail, newsletterPopSubmit)
    newsletterPopSubmit.addEventListener('click', () => {
      let valid = true

      if(!validateEmail(newsletterPopEmail.value)) {
        valid = false
        const wrap = newsletterPopEmail.closest('.input-wrap')
        wrap?.classList.add('input-error')
        wrap?.querySelector(`[${qs.fieldError}]`).classList.remove('hidden')
      }
      if(!newsletterPopTitle.value) {
        valid = false
        const wrap = newsletterPopTitle.closest('.select-wrap')
        wrap?.classList.add('select-error')
        wrap?.querySelector(`[${qs.fieldError}]`).classList.remove('hidden')
      }

      if(!newsletterPopFirstName.value) {
        valid = false
        const wrap = newsletterPopFirstName.closest('.input-wrap')
        wrap?.classList.add('input-error')
        wrap?.querySelector(`[${qs.fieldError}]`).classList.remove('hidden')
      }
      if(valid) {
        newsletterPopSubmit.classList.add('button--loading', 'button--primary')

        const newsletterGender = document.querySelector('[name="newsletterPopInterest"]:checked')?.value || ""

        fetch(`https://${window.tbApiDomain}/upsert_lead`, {
          method: 'POST',
          headers: new Headers({
            'Content-Type': 'application/json',
            Accept: 'application/json'
          }),
          body: JSON.stringify(
            {
              "lead": {
                "salutation": newsletterPopTitle?.value,
                "first_name": newsletterPopFirstName?.value,
                "last_name": newsletterPopLastName?.value,
                "email": newsletterPopEmail?.value,
                "country": newsletterPopCountry?.value,
                "interests": newsletterGender,
                "language": Shopify.locale,
                "marketing_consent_flag": true,
                "privacy_consent_flag": true
              }
            }
          ),
        })
          .then((response) => response.text())
          .then((result) => {
            console.log(result)
            if(result == 'ok') {
              window.openPopup(`<div class="p-12.5 w-full lg:w-[32.75rem] text-center text-sm">${window.accountStrings.footer.newsletter.success}</div>`)

              // Calculate SHA-256 hash of the email before sending it to analytics
              sha256(newsletterPopEmail?.value).then(hashedEmail => {
                Shopify.analytics.publish('gtm_sign_up_newsletter',{
                  newsletter_gender: newsletterGender,
                  email_sha256: hashedEmail
                });
              });

              // Naver pixel
              if(window.wcs){
                var _conv = {};
                _conv.type = 'subscribe';
                wcs.trans(_conv);
              }
            } else {
              newsletterPopSubmit.classList.remove('button--loading', 'button--primary')
            }
          })
          .catch((e) => {
            console.error(e)
            newsletterPopSubmit.classList.remove('button--loading', 'button--primary')
          })
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', function() {
  const cookiePreferences = document.querySelectorAll('[href*="#oneTrustOpener"]');

  if (cookiePreferences.length > 0) {
    cookiePreferences.forEach(cookiePreference => {
      cookiePreference.addEventListener('click', function(e) {
        e.preventDefault();
        if (typeof OneTrust !== 'undefined' && typeof OneTrust.ToggleInfoDisplay === 'function') {
            OneTrust.ToggleInfoDisplay();
        }
      });
    });
  }

  document.addEventListener('click', function(e) {
    console.log("target", e.target)
    const noGDPRBanner = document.querySelectorAll('[aria-label="Cookie banner - No GDPR"]');
    if (e.target.classList.contains('onetrust-close-btn-ui') && noGDPRBanner.length > 0) {
      if (typeof OneTrust !== 'undefined' && typeof OneTrust.AllowAll === 'function') {
          OneTrust.AllowAll();
      }
    }
  });

});



export const setupFooter = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    dom.newsletterPopTrigger.addEventListener('click', () => {
      window.openPopup(document.querySelector('#signup-popup').innerHTML, null, dom.newsletterPopTrigger)
      initSignupForm()
    })
  }
}
